export default __webpack_public_path__ + "static/media/revamped.91c72a3e.JPG";